import {cva, VariantProps} from "class-variance-authority";
//@ts-ignore
import type { PrimitiveProps } from "radix-vue";
import {HTMLAttributes} from "vue";

export {default as Grid} from './Grid.vue'
export {default as HStack} from './HStack.vue'
export {default as VStack} from './VStack.vue'
export {default as Columns} from './Columns.vue'
export {default as Column} from './Column.vue'

export interface GridProps extends PrimitiveProps {
    columns?: GridVariants['columns']
    override?: GridVariants['override']
    as?: string
    class?: HTMLAttributes['class']
}
export const gridVariants = cva(
    '',
    {
        variants: {
            columns: {
                0: 'flex gap-default',
                1: 'grid gap-y-default sm:gap-x-default grid-cols-1 xl:grid-cols-1',
                2: 'grid gap-y-default sm:gap-x-default grid-cols-1 xl:grid-cols-2',
                3: 'grid gap-y-default sm:gap-x-default grid-cols-1 xl:grid-cols-3',
                4: 'grid gap-y-default sm:gap-x-default grid-cols-1 xl:grid-cols-4',
                5: 'grid gap-y-default sm:gap-x-default grid-cols-1 xl:grid-cols-5',
                6: 'grid gap-y-default sm:gap-x-default grid-cols-1 xl:grid-cols-6',
                7: 'grid gap-y-default sm:gap-x-default grid-cols-1 xl:grid-cols-7',
                8: 'grid gap-y-default sm:gap-x-default grid-cols-1 xl:grid-cols-8',
                9: 'grid gap-y-default sm:gap-x-default grid-cols-1 xl:grid-cols-9',
                10: 'grid gap-y-default sm:gap-x-default grid-cols-1 xl:grid-cols-10',
                11: 'grid gap-y-default sm:gap-x-default grid-cols-1 xl:grid-cols-11',
                12: 'grid gap-y-default sm:gap-x-default grid-cols-1 xl:grid-cols-12',
            },
            override: {
                true: 'col-span-full',
                false: ''
            }
        },
        defaultVariants: {
            columns: 1,
            override: false,
        },
    },
)
export type GridVariants = VariantProps<typeof gridVariants>

export interface GridItem {
    colSpan?: GridItemVariants['colSpan']
}

export const gridItemVariants = cva(
    '',
    {
        variants: {
            colSpan: {
                1: 'col-span-1',
                2: 'col-span-2',
                3: 'col-span-3',
                4: 'col-span-4',
                5: 'col-span-5',
                6: 'col-span-6',
                7: 'col-span-7',
                8: 'col-span-8',
                9: 'col-span-9',
                10: 'col-span-10',
                11: 'col-span-11',
                12: 'col-span-12',
            }
        },
        defaultVariants: {
            colSpan: 1,
        },
    },
)
export type GridItemVariants = VariantProps<typeof gridItemVariants>

export const hstackVariants = cva(
    'flex flex-row gap-default',
    {
        variants: {
            align: {
                'start': 'items-start',
                'center': 'items-center',
                'end': 'items-end',
                'stretch': 'items-stretch'
            },
            justify: {
                'start': 'justify-start',
                'center': 'justify-center',
                'end': 'justify-end',
                'space-between': 'justify-between',
                'space-around': 'justify-around',
                'space-space-evenly': 'justify-evenly',
            }
        },
        defaultVariants: {
            justify: 'space-between',
        },
    },
)
export type HStackVariants = VariantProps<typeof hstackVariants>

export const vstackVariants = cva(
    'flex flex-col gap-default',
    {
        variants: {
            align: {
                'start': 'items-start',
                'center': 'items-center',
                'end': 'items-end',
                'stretch': 'items-stretch'
            },
            justify: {
                'start': 'justify-start',
                'center': 'justify-center',
                'end': 'justify-end',
                'space-between': 'justify-between',
                'space-around': 'justify-around',
                'space-space-evenly': 'justify-evenly',
            }
        },
        defaultVariants: {
            align: 'start',
            justify: 'space-between'
        },
    },
)
export type VStackVariants = VariantProps<typeof vstackVariants>